// Core Facebook Pixel initialization and event tracking functions

/**
 * Initializes the Facebook Pixel with the given pixel ID.
 * Prevents re-initialization if fbq is already loaded and initialized for this ID.
 * @param {string} pixelId - The Facebook Pixel ID.
 */
export function initPixel(pixelId, options) {
  if (window.fbq) {
    // Check if the pixel has already been initialized to prevent duplicate calls
    // Note: fbq('init', pixelId) is idempotent if called multiple times with the same ID.
    window.fbq("init", pixelId, options);
    console.log(`Facebook Pixel ${pixelId} initialized.`);
  } else {
    console.error("Facebook Pixel not loaded (window.fbq is undefined).");
  }
}

/**
 * Tracks a standard Facebook Pixel event.
 * @param {string} eventName - The name of the event (e.g., 'PageView', 'Purchase').
 * @param {object} [eventData={}] - An object containing event-specific parameters.
 * @param {object} [options={}] - An object containing additional options like eventID, fbc, fbp, user_data.
 */
export function trackEvent(eventName, eventData = {}, options = {}) {
  if (window.fbq) {
    window.fbq("track", eventName, eventData, options);
  } else {
    console.error("Facebook Pixel not loaded.");
  }
}

/**
 * Tracks a Facebook Pixel event for a specific pixel ID.
 * This is useful when multiple pixels are loaded on the same page.
 * @param {string} pixelId - The specific Facebook Pixel ID to track the event on.
 * @param {string} eventName - The name of the event.
 * @param {object} [eventData={}] - An object containing event-specific parameters.
 * @param {object} [options={}] - An object containing additional options like eventID, fbc, fbp, user_data.
 */
export function trackEventSingle(
  pixelId,
  eventName,
  eventData = {},
  options = {}
) {
  if (window.fbq) {
    // Meta's documentation suggests sending event_id, fbc, fbp, user_data via the options object for 'track' and 'trackSingle'
    // Ensure options are passed correctly for advanced matching and deduplication
    window.fbq("trackSingle", pixelId, eventName, eventData, options);
  } else {
    console.error("Facebook Pixel not loaded.");
  }
}
